export default function ({ next, store, nextMiddleware, to }) {
  store.getters.isUserLoggedIn
    ? nextMiddleware()
    : next({
        name: "login",
        query: { to: to.fullPath },
        replace: true,
      });
}
